import {ASPathButton} from "../../components/ActionStripButtons";
import routes from "../../routes";
import {ShortcutHelp} from "../../features/card-panel/ActionButtons";
import {Col, DSIconBarChart, DSIconHistory} from "@cdx/ds";

const OverviewActionButtons = ({location, history}) => {
  const category = "Deck overview";
  const rootPath = routes.decks.path;
  const rootUrl = routes.decks.getUrl();

  return (
    <Col>
      <Col flex="auto">
        <Col sp="12px" position="sticky" top={0} pt="12px">
          <ASPathButton
            pathSegement="metrics"
            rootPath={rootPath}
            rootUrl={rootUrl}
            location={location}
            history={history}
            tooltip="Show metrics"
            shortcut={{code: "KeyM", withShift: true, category, description: "Open metrics"}}
            icon={<DSIconBarChart />}
          />
          <ASPathButton
            pathSegement="activity"
            rootPath={rootPath}
            rootUrl={rootUrl}
            location={location}
            history={history}
            tooltip="Browse recent activity"
            shortcut={{code: "KeyI", withShift: true, category, description: "Open activity panel"}}
            icon={<DSIconHistory />}
          />
        </Col>
      </Col>
      <ShortcutHelp />
    </Col>
  );
};

export default OverviewActionButtons;
